var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Hola")]),(_vm.ready)?_c('edit-user',{attrs:{"uuid":_vm.user.uuid}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }